// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.order.CreateContactLensOrderRequest */
/* istanbul ignore next */
@GandalfModel
export class CreateContactLensOrderRequest extends GandalfModelBase {

	@GandalfLabel('Contact Lens Prescription')
	@GandalfValidator({ notNull: { message: 'Contact Lens Prescription is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	contactLensPrescriptionId!: number;

	@GandalfLabel('Order Processor')
	@GandalfProperty({ designType: Number })
	orderProcessorConfigId!: number | null;

	@GandalfLabel('Patient')
	@GandalfValidator({ notNull: { message: 'Patient is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	patientId!: number;

}
